import { createReducer } from '@reduxjs/toolkit';
import { WINDOW_FOCUSED } from '../constants';

export default createReducer(true, {
  [WINDOW_FOCUSED]: (state, action) => action.payload,
});
